import Vue from 'vue';

export const notificationsListingService = {
  retrieveNotifications() {
    return Vue.axios.get('/notifications').then(response => response.data);
  },

  retrieveNotificationsByReferenceNumber(referenceNumber) {
    return Vue.axios.get(`/notifications/${referenceNumber}`).then(response => response.data);
  },

  deleteNotifications(notificationIds) {
    return Vue.axios
      .delete('/notifications', {
        data: notificationIds
      })
      .then(response => response.data);
  },

  updateNotifications(notificationAction, notificationIds) {
    return Vue.axios
      .put('/notifications', {
        notificationAction,
        notificationIds
      })
      .then(response => response.data);
  }
};
